if(!customElements.get('facet-filters-form')){
    class FacetFiltersForm extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.sortingSelectWrapper = this.querySelector('.sorting-select-wrapper');

            this.btnSortingOptionSelector = this.sortingSelectWrapper.querySelector('.btn-selected');
            this.btnSortingOptionSelector.addEventListener('click', this.openSortingOption.bind(this));
            this.btnSortingOptionSelector.addEventListener('focusout', this.closeSortingOption.bind(this));
            document.addEventListener('click', (event) => {
                if(!event.target.classList.contains('sorting-select-wrapper') && event.target.closest('.sorting-select-wrapper') == null){
                    this.closeSortingOption(event);
                }
            })

            this.inputSorting = this.sortingSelectWrapper.querySelector('#SortBy');

            this.btnSortingOptionSelector.querySelectorAll('.sorting-select-options li').forEach(item => {
                item.addEventListener('click', e => {
                    this.clickSortingOption(e);
                })
                item.addEventListener('keydown', this.optionKeydownEventHandler.bind(this));
            })

            this.form = this.querySelector('#FacetForm');
            this.inputs = this.form.querySelectorAll('input');

            // add facets filter sidebar inputs to this.inputs
            this.sidebarFilter = document.querySelector('sidebar-filter');
            this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];

            if(this.dataset.content == 'collection'){ // collection

                this.productList = this.closest('custom-collection-product-list');
                this.facetRemoveWrapper = this.productList.querySelector('.collection-product-list__active-tags');
                this.products = this.productList.querySelector('#collection-product-list__products');
                this.totalNumberOfProducts = this.productList.querySelector('.collection-product-list__total-number');
                this.productsWrapper = this.productList.querySelector('.collection-product-list__products-wrapper');
                this.facetWrapper = this.closest('.collection-facet-wrapper');

            }else if(this.dataset.content == 'search'){ // search

                this.productList = this.closest('custom-search-product-list');
                this.facetRemoveWrapper = this.productList.querySelector('.search-product-list__active-tags');
                this.products = this.productList.querySelector('#search-item-list__items');
                this.totalNumberOfProducts = this.productList.querySelector('.search-product-list__total-number');
                this.productsWrapper = this.productList.querySelector('.search-item-list__items-wrapper');
                this.facetWrapper = this.closest('.search-facet-wrapper');

            }

            this.btnColumnSwitch = this.productList.querySelector('.product-view-switch-wrapper');
            this.btnLoadMore = this.productList.querySelector('.btn-load-more');
            this.btnFilter = this.querySelector('.product-filter-button');
            this.btnFilter.addEventListener('click', this.openSidebarFilter.bind(this));
            this.btnFilter.addEventListener('keydown', (event) => {
                if(event.key === "Enter"){
                    this.openSidebarFilter();
                }
            })
        }

        refresh(){
            this.init();
        }

        openSidebarFilter(){
            this.sidebarFilter.openSidebarFilter();
        }

        openSortingOption(e){
            e.preventDefault();

            if(e.target.nodeName !== 'LI' && e.target.closest('li') == null){
                e.currentTarget.querySelector('.sorting-select-options').setAttribute('data-hidden', 'false');

                const options = this.btnSortingOptionSelector.querySelectorAll('.sorting-select-options li');
                let index = 0;

                options.forEach(item => {
                    item.setAttribute('tabindex', '0');
                });

                const focusElem = setInterval(() => {
                    const firstOption = options[0];
                    firstOption.focus();
                    var focusedElement = document.activeElement;

                    index++;
                    if(focusedElement === firstOption || index > 5){
                        clearInterval(focusElem);
                    }
                }, 100);
            }
        }

        optionKeydownEventHandler(event){
            const options = this.btnSortingOptionSelector.querySelectorAll('.sorting-select-options li');
            if(event.key === 'ArrowDown'){
                event.preventDefault();
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex + 1;
                    if(focusableElements[nextIndex]){
                        focusableElements[nextIndex].focus();
                    }else{
                        event.currentTarget.closest('.sorting-select-options').setAttribute('data-hidden', 'true');
                        options.forEach(item => {
                            item.setAttribute('tabindex', '-1');
                        })
                    }
                }
            }else if(event.key === 'ArrowUp'){
                event.preventDefault();
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex === 0 ? 0 : currentIndex - 1;
                    focusableElements[nextIndex].focus();
                }
            }else if(event.key === 'Escape'){
                event.currentTarget.closest('.sorting-select-options').setAttribute('data-hidden', 'true');
                options.forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }else if(event.key === 'Enter'){
                this.clickSortingOption(event);
            }else if(event.key === 'Tab'){
                if(options.length > 0){
                    var focusableElements = options;
                    var currentIndex = Array.from(focusableElements).indexOf(document.activeElement);
                    var nextIndex = currentIndex + 1;
                    if(focusableElements[nextIndex]){
                    }else{
                        event.currentTarget.closest('.sorting-select-options').setAttribute('data-hidden', 'true');
                        options.forEach(item => {
                            item.setAttribute('tabindex', '-1');
                        })
                    }
                }
            }
        }

        closeSortingOption(e){
            if(e.relatedTarget == null || (e.relatedTarget && e.relatedTarget.nodeName === 'BUTTON')){
                e.currentTarget.querySelector('.sorting-select-options').setAttribute('data-hidden', 'true');
                e.currentTarget.querySelectorAll('.sorting-select-options li').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }
        }

        clickSortingOption(e){
            e.currentTarget.closest('.sorting-select-options').setAttribute('data-hidden', 'true');
            this.btnSortingOptionSelector.querySelector('.sort-by').innerHTML = `${e.currentTarget.dataset.option}`;

            this.inputSorting.setAttribute('value', `${e.currentTarget.dataset.optionValue}` );
            this.inputSorting.value = `${e.currentTarget.dataset.optionValue}`;

            if(e.currentTarget.closest('.sorting-select-options')){
                e.currentTarget.closest('.sorting-select-options').querySelectorAll('li').forEach(item => {
                    item.setAttribute('tabindex', '-1');
                })
            }

            this.submitForm();
        }

        submitForm(){
            // disable sideform filter
            this.sidebarFilter.setAttribute('data-disable', 'true');

            var params = new URLSearchParams();
            this.inputs.forEach(item => {
                if(item.classList.contains('checkbox')){
                    var itemId = item.getAttribute('id');
                    var itemLabel = this.sidebarFilter.querySelector('label[for="'+ itemId +'"]');
                    if(itemLabel && itemLabel.getAttribute('data-checked') == 'true') params.append(item.name, item.value);
                }else{
                    params.append(item.name, item.value);
                }
            })

            const queryString = params.toString();
            const currentURL = this.dataset.url + '?' + queryString;

            this.loadProducts(currentURL);
            this.updateURL(currentURL);
        }

        submitFormByURL(newURL){
            // disable sideform filter
            this.sidebarFilter.setAttribute('data-disable', 'true');

            this.loadProducts(newURL, true);
            this.updateURL(newURL);
        }

        async loadProducts(currentURL, actionRemove = false, fromInputSearch = false){
            try{
                const pageRes = await fetch(
                    `${currentURL}`
                );
                const pageText = await pageRes.text();
                const pageHTML = new DOMParser().parseFromString(pageText, 'text/html');

                const productsWrapper = this.dataset.content == 'collection'?
                    pageHTML.querySelector('#collection-product-list__products-wrapper') :
                    pageHTML.querySelector('#search-item-list__items-wrapper');

                const products = this.dataset.content == 'collection'?
                    productsWrapper.querySelector('#collection-product-list__products') :
                    productsWrapper.querySelector('#search-item-list__items');

                const facetRemoveWrapper = this.dataset.content == 'collection'?
                    pageHTML.querySelector('.collection-product-list__active-tags') :
                    pageHTML.querySelector('.search-product-list__active-tags');

                const sidebarFilter = pageHTML.querySelector('sidebar-filter');

                const totalNumberOfProducts = this.dataset.content == 'collection'?
                    pageHTML.querySelector('.collection-product-list__total-number') :
                    pageHTML.querySelector('.search-product-list__total-number');

                const formFacetFilter = pageHTML.querySelector('facet-filters-form');
                
                if(productsWrapper.dataset.empty == 'true'){
                    // product is empty
                    this.products.innerHTML = '';
                    this.products.appendChild(products.querySelector('.product-list__products--empty'));

                    if(this.btnColumnSwitch) this.btnColumnSwitch.setAttribute('data-hidden', 'true');
                    if(this.facetWrapper) this.facetWrapper.setAttribute('data-hidden', 'true');
                    if(this.btnLoadMore) this.btnLoadMore.classList.add('d-none');
                }else{
                    const btnLoadMore = productsWrapper.querySelector('.btn-load-more');
                    this.products.innerHTML = '';
                    
                    // get product
                    const productCards = products.querySelectorAll('.product-card__wrapper, .article-card__wrapper, .page-card__wrapper');
                    productCards.forEach(item => {
                        if(this.btnColumnSwitch.dataset.column == '3'){
                            item.classList.add('col-xl-3');
                            item.classList.add('col-6');
                            item.classList.remove('col-xl-4');
                            item.classList.remove('col-12');
                        }else{
                            item.classList.add('col-xl-4');
                            item.classList.add('col-12');
                            item.classList.remove('col-xl-3');
                            item.classList.remove('col-6');
                        }
    
                        this.products.appendChild(item);
                    });
    
                    if(btnLoadMore && !btnLoadMore.classList.contains('d-none')){
                        if(this.btnLoadMore){
                            this.btnLoadMore.classList.remove('d-none');
                            this.btnLoadMore.setAttribute('data-url', `${btnLoadMore.dataset.url}`);
                            
                            const btnLoadMoreWrapper = this.btnLoadMore.closest('pagination-button');
                            if(btnLoadMoreWrapper){
                                btnLoadMoreWrapper.classList.remove('d-none');
                                btnLoadMoreWrapper.classList.add('d-block');
                                btnLoadMoreWrapper.classList.add('pt-5');
                                btnLoadMoreWrapper.classList.add('my-5');
                            }
                        }
                    }else{
                        if(this.btnLoadMore) this.btnLoadMore.classList.add('d-none');
                    }

                    if(this.btnColumnSwitch) this.btnColumnSwitch.setAttribute('data-hidden', 'false');
                    if(this.facetWrapper) this.facetWrapper.setAttribute('data-hidden', 'false');
                }

                // update sidebar filter
                // FIX: zowel bij normaal filteren als bij het verwijderen van een actief filter
                // (maar niet vanuit de zoekbalk) moet de volledige <li> ververst worden -
                // inclusief class (is-disabled) en het disabled-attribuut van de input.
                // updateSidebarFilterLabel deed alleen de labeltekst, en de oude
                // updateSidebarFilter matchte op index (ging stuk zodra volgorde/lengte
                // verschilde). Beide zijn vervangen door updateSidebarFilterFacets hieronder.
                if(fromInputSearch){
                    this.replaceSidebarFilter(sidebarFilter);
                    this.updateFacetFilterUrl(formFacetFilter.dataset.url);
                }else{
                    this.updateSidebarFilterFacets(sidebarFilter);
                }

                this.updateFacetTag(facetRemoveWrapper);
                this.updateTotalNumberItem(totalNumberOfProducts);
            } catch(error){
                console.error(error);
                // alert(error.message);
            } finally {
                if(this.btnLoadMore) this.btnLoadMore.setAttribute('data-disabled', 'false');
                this.sidebarFilter.setAttribute('data-disable', 'false');
            }
        }

        updateFacetFilterUrl(url){
            this.dataset.url = url;
        }

        updateURL(currentURL){
            window.history.replaceState({ }, '', `${currentURL}`);
        }

        updateTotalNumberItem(totalNumberOfProducts){
            // FIX: deze methode was per ongeluk verdwenen bij het verwijderen van
            // updateSidebarFilterLabel / updateSidebarFilter, terwijl de aanroep in
            // loadProducts bleef staan. Resultaat: TypeError na elke filterklik.
            if(this.totalNumberOfProducts && totalNumberOfProducts)
                this.totalNumberOfProducts.innerHTML = totalNumberOfProducts.innerHTML;
        }

        updateSidebarFilterFacets(sidebarFilter){
            // FIX: matchen op de unieke combinatie van input-name + input-value in plaats van
            // op array-index. Index-matching ging stuk zodra de volgorde of het aantal
            // facetwaarden verschilde tussen de oude en de nieuw opgehaalde HTML (bijvoorbeeld
            // omdat een andere filtergroep van lengte veranderde, waardoor labels van de ene
            // groep in de verkeerde <li> van een andere groep belandden). Door het volledige
            // <li>-element (outerHTML) te vervangen, komen class="is-disabled" en het
            // disabled-attribuut van de input altijd correct mee - niet alleen de labeltekst.
            const newElems = sidebarFilter.querySelectorAll('.facet__elem');

            newElems.forEach(newElem => {
                const newInput = newElem.querySelector('input');
                if(!newInput) return;

                const key = newInput.name + '::' + newInput.value;
                const currentInput = Array.from(this.sidebarFilter.querySelectorAll('.facet__elem input'))
                    .find(input => (input.name + '::' + input.value) === key);

                if(currentInput){
                    const currentElem = currentInput.closest('.facet__elem');
                    if(currentElem) currentElem.outerHTML = newElem.outerHTML;
                }
            });

            // update price
            if(this.sidebarFilter.querySelector('.facet__price')){
                this.sidebarFilter.querySelector('.facet__price').innerHTML = sidebarFilter.querySelector('.facet__price').innerHTML;
            }

            // update inputs
            this.inputs = this.form.querySelectorAll('input');
            this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];

            // re-initialize sidefilter after replacing elements
            this.sidebarFilter.init();

            // FIX: het accordion-component zet een vaste inline hoogte op .accordion-text
            // (bijv. style="height: calc(886px + 2rem)") die berekend is toen alle
            // filterwaarden nog zichtbaar waren. Na het filteren vallen waarden met 0
            // producten weg via display:none, maar die inline hoogte bleef staan - vandaar
            // de lege ruimte onder de zichtbare streken/druivenrassen. Hier wordt de hoogte
            // opnieuw berekend op basis van de werkelijke contenthoogte.
            this.recalculateAccordionHeights();
        }

        recalculateAccordionHeights(){
            this.sidebarFilter.querySelectorAll('custom-accordion').forEach(accordion => {
                const textWrapper = accordion.querySelector('.accordion-text');
                const inner = accordion.querySelector('.accordion-text__inner');
                if(!textWrapper || !inner) return;

                if(accordion.getAttribute('data-open') === 'true'){
                    textWrapper.style.height = `calc(${inner.scrollHeight}px + 2rem)`;
                }else{
                    // dichte accordeons hebben geen expliciete hoogte nodig; de eventueel
                    // achtergebleven waarde wordt verwijderd zodat de volgende opening
                    // opnieuw correct wordt berekend
                    textWrapper.style.removeProperty('height');
                }
            });
        }

        replaceSidebarFilter(sidebarFilter){
            this.sidebarFilter.innerHTML = sidebarFilter.innerHTML;

            // re-initialize sidefilter after replacing the content
            this.sidebarFilter.init();

            // update inputs
            this.inputs = this.form.querySelectorAll('input');

            // add facets filter sidebar inputs to this.inputs
            this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];

        }

        updateFacetTag(facetRemoveWrapper){
            this.facetRemoveWrapper.innerHTML = facetRemoveWrapper.innerHTML;
            this.facetRemoveWrapper.setAttribute('data-hidden', facetRemoveWrapper.getAttribute('data-hidden'));
        }
    }

    customElements.define('facet-filters-form', FacetFiltersForm);
}

if(!customElements.get('sidebar-filter')){
    class SidebarFilter extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.facetForm = document.querySelector('facet-filters-form');

            this.btnClose = this.querySelector('.btn-close');
            this.btnClose.addEventListener('click', e => {
                this.setAttribute('data-hidden', 'true');
                document.querySelector('html').style.overflow = 'initial';

                if(this.previouslyFocusedElement){
                    this.previouslyFocusedElement.focus();
                }
            });
            this.addEventListener('keydown', (event) => {
                if(event.key === 'Escape'){
                    this.setAttribute('data-hidden', 'true');
                    document.querySelector('html').style.overflow = 'initial';

                    if(this.previouslyFocusedElement){
                        this.previouslyFocusedElement.focus();
                    }
                }
            })

            this.addEventListener('click', e => {
                if(e.target.nodeName == 'SIDEBAR-FILTER'){
                    this.setAttribute('data-hidden', 'true');
                    document.querySelector('html').style.overflow = 'initial';

                    if(this.previouslyFocusedElement){
                        this.previouslyFocusedElement.focus();
                    }
                }
            })

            this.inputWrappers = this.querySelectorAll('.input-wrapper');
            this.inputs = this.querySelectorAll('.input-wrapper input');
            this.inputs.forEach(item => {
                item.addEventListener('focus', this.focusOnInput.bind(this));
                item.addEventListener('focusout', this.focusOutOnInput.bind(this));
                item.addEventListener('change', this.updateInput.bind(this));
            });

            this.checkboxs = this.querySelectorAll('input[type="checkbox"]');
            this.labels = [];
            this.checkboxs.forEach(item => {
                // FIX: hier stonden "item.disabled = false;" en "item.checked = false;".
                // Dat forceerde op ELKE checkbox, bij ELKE init() (dus ook na elke
                // AJAX-herinitialisatie), het disabled- en checked-attribuut terug naar
                // false/leeg - waardoor de door Shopify/Liquid correct berekende disabled-
                // status (0 producten) en checked-status (actief filter) meteen weer werden
                // overschreven. De HTML-attributen die de server rendert zijn nu leidend.

                var label = this.querySelector('label[for="'+ item.getAttribute('id')+'"]');
                this.labels.push(label);
                label.addEventListener('click', e => {
                    this.clickOnFilterValue(e.currentTarget);
                });
                item.addEventListener('keydown', e => {
                    if(e.key === 'Enter'){
                        this.clickOnFilterValue(label);
                    }
                })
            });

            this.btnClear = this.querySelector('.sidebar__filter-btn-clear');
            this.btnClear.addEventListener('click', this.clearAllFilter.bind(this));
            this.btnClear.addEventListener('keydown', (event) => {
                if(event.key === 'Enter'){
                    this.clearAllFilter();
                }
            })

            this.btnDone = this.querySelector('.slidebar__filter-btn-done');
            this.btnDone.addEventListener('click', e => {
                this.setAttribute('data-hidden', 'true');
                document.querySelector('html').style.overflow = 'initial';

                if(this.previouslyFocusedElement){
                    this.previouslyFocusedElement.focus();
                }
            })
        }

        refresh(){
            this.init();
        }

        openSidebarFilter(){
            this.previouslyFocusedElement = document.activeElement;
            
            this.setAttribute('data-hidden', 'false');
            document.querySelector('html').style.overflow = 'hidden';

            let index = 0;
            const focusElem = setInterval(() => {
                // make accordion focusable
                var firstItem = this.querySelectorAll('.accordion-heading')[0];
                firstItem.focus();

                var focusedElement = document.activeElement;

                index++;
                if(focusedElement === firstItem || index > 5) clearInterval(focusElem);
            }, 100);

            this.accordions = this.querySelectorAll('custom-accordion');
            this.accordions.forEach((item, index) => {
                item.addEventListener('keydown', (event) => {
                    if(event.key === 'Tab'){
                        // check if current accordion is open, if so focus on the next element, otherwise, move to next one
                        if(item.getAttribute('data-open') === 'false'){
                            if(this.accordions[index + 1]){
                                const focusElem = setInterval(() => {
                                    let activeItem = this.accordions[index + 1];
                                    activeItem.focus();
                                    let focusedElement = document.activeElement;

                                    index++;
                                    if(focusedElement === activeItem || index > 5) clearInterval(focusElem);
                                }, 100);
                            }
                        }
                    }
                })
            })
        }

        clearAllFilter(){
            // remove all checkbox selection
            this.checkboxs.forEach(item => {
                item.removeAttribute('checked');
                var label = this.querySelector('label[for="'+ item.getAttribute('id') +'"]');
                label.setAttribute('data-checked', 'false');
            })

            // remove all price range
            this.querySelectorAll('input[type="number"]').forEach(item => {
                item.value = '';
            });
            this.focusOutOnInput();

            this.facetForm.submitForm();
        }

        clickOnFilterValue(label){
            var checkboxWrapper = label.closest('.facet__elem');
            var checkbox = checkboxWrapper.querySelector('input[type="checkbox"]');

            if(label.getAttribute('data-checked') != 'true'){
                label.setAttribute('data-checked', 'true');
                checkbox.setAttribute('checked', 'checked');

                this.facetForm.submitForm();

                return;
            }

            label.setAttribute('data-checked', 'false');
            label.getAttribute('data-checked')
            checkbox.removeAttribute('checked');

            this.facetForm.submitForm();
        }

        focusOnInput(e){
            this.inputWrappers.forEach(item => {
                var input = item.querySelector('input');
                if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
            })

            var currentTarget = e.currentTarget;
            var currentTargetInputWrapper = currentTarget.closest('.input-wrapper');
            currentTargetInputWrapper.setAttribute('data-selected', 'true');
        }

        focusOutOnInput(){
            this.inputWrappers.forEach(item => {
                var input = item.querySelector('input');
                if(input.value.trim() == '') item.setAttribute('data-selected', 'false');
            })
        }

        updateInput(e){
            this.facetForm.submitForm();
        }
    }

    customElements.define('sidebar-filter', SidebarFilter);
}

if(!customElements.get('facet-remove')){
    class FacetRemove extends HTMLElement {
        constructor(){
            super();

            this.init();
        }

        init(){
            this.productList = this.closest('custom-collection-product-list')? this.closest('custom-collection-product-list') : this.closest('custom-search-product-list');
            this.facetFiltersForm = this.productList.querySelector('facet-filters-form');
            this.form = this.productList.querySelector('#FacetForm');
            
            this.inputs = this.form.querySelectorAll('input');
            
            // add facets filter sidebar inputs to this.inputs
            this.sidebarFilter = document.querySelector('sidebar-filter');
            this.inputs = [...this.inputs, ...this.sidebarFilter.querySelectorAll('input')];

            this.link = this.querySelector('a');
            this.link.addEventListener('click', this.removeFacet.bind(this));
        }

        refresh(){
            this.init();
        }

        removeFacet(e){
            e.preventDefault();

            var href = this.link.getAttribute('href');
            this.facetFiltersForm.submitFormByURL(href);

            this.setAttribute('data-hidden', 'true');
        }
    }

    customElements.define('facet-remove', FacetRemove);
}